<script lang="ts" module>
  export type Breadcrumb =
    | string
    | {
        title: string;
        url: string;
      };
</script>

<script lang="ts">
  let { breadcrumbs }: { breadcrumbs: Breadcrumb[] } = $props();
</script>

<div class="bg-base-100 text-base-content sticky top-0 z-20 text-xs">
  <div class="breadcrumbs">
    <ul>
      {#each breadcrumbs as crumb}
        {#if typeof crumb === 'string'}
          <li>{crumb}</li>
        {:else}
          <li><a href={crumb.url}>{crumb.title}</a></li>
        {/if}
      {/each}
    </ul>
  </div>
</div>
